import { FILTER_TYPE } from 'components/FiltersBlock/types';

export const SUBNET_FILTER = (network: number | undefined) => {
  return {
    label: 'Подсеть',
    name: 'subnet',
    type: FILTER_TYPE.SELECT,
    showSearch: true,
    apiUrl: network ? `/api/standards/engineering_networks/${network}/subnets/?page=1` : '',
  };
};

export const SUBNET_TYPE_FILTER = {
  label: 'Подсеть',
  name: 'subnet',
  type: FILTER_TYPE.SELECT,
  showSearch: true,
  apiUrl: '/api/standards/engineering_networks/subnet_types/?page=1',
};

export const SUBNET_TYPE_EN_TYPE_FILTER = (network_type: number | undefined) => {
  return {
    label: 'Подсеть',
    name: 'subnet_type',
    type: FILTER_TYPE.SELECT,
    showSearch: true,
    apiUrl: network_type
      ? `/api/standards/engineering_networks/subnet_types/?page=1&en_type=${network_type}`
      : undefined,
  };
};

export const SUBNET_ENG_FILTER = {
  label: 'Подсеть',
  name: 'subnet',
  type: FILTER_TYPE.SELECT,
  apiUrl: '/api/standards/structures/engineering_subnets/?page=1',
};

export const SUBNET_ENG_FILTER_NET_IN_URL = (network: number | undefined) => {
  return {
    label: 'Подсеть',
    name: 'subnet',
    type: FILTER_TYPE.SELECT,
    apiUrl: network ? `/api/standards/structures/engineering_subnets/${network}/?page=1` : '',
  };
};
